import React from "react";
import {messages} from "../common/Translations";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import InterestsForm from "./InterestsForm";
import * as interestsActions from "../../actions/interests/interestsActions";
import {bindActionCreators} from "redux";
import {toastr} from "react-redux-toastr";
import * as submitButtonActions from "../../actions/submit/submitButtonActions";
import InterestsFormSerializer from "../../services/InterestsFormSerializer";

class InterestsFormContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.actions = [];

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        const {user} = this.props;

        this.props.actions.loadPortalsCategories();
        this.props.actions.loadInterests(user.id);
    }

    submit(data) {
        this.props.actions.showSubmitButtonSpinner();

        const {user} = this.props;
        this.props.actions.updateInterests(user.id, InterestsFormSerializer.serialize(data)).then(() => {
            toastr.success(this.props.intl.formatMessage(messages.interestsFormUpdated));
            this.props.actions.hideSubmitButtonSpinner();
        });
    }

    render() {
        const {portalsCategories, interests} = this.props;

        return (
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <h1 className="mb-3">{this.props.intl.formatMessage(messages.interests)}</h1>
                                <InterestsForm
                                    initialValues={interests}
                                    portalsCategories={portalsCategories}
                                    enableReinitialize={true}
                                    keepDirtyOnReinitialize={true}
                                    onSubmit={this.submit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        portalsCategories: state.portalsCategories,
        user: state.user,
        interests: InterestsFormSerializer.unserialize(state.interests),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                interestsActions,
                submitButtonActions,
            ), dispatch
        )
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(InterestsFormContainer));


// WEBPACK FOOTER //
// ./web/src/components/interests/InterestsFormContainer.jsx